import gql from 'graphql-tag';

export default gql`
    query GetUserFiltered($input: String) {
        getUserFiltered(input: $input) {
            id
            name
            emailAddress
            roleId
            isActive
            status
        }
    }
`;
